// @ts-nocheck
import { chain, GoToUrl as baseGoToUrl } from "@insite/client-framework/Store/CommonHandlers/StartSearch";
import constants from "@store/constants";
import getContentSearchUrl from "@store/Framework/Common/Utilities/getContentSearchUrl";
import { getContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const GoToUrl = createChainHandler("GoToUrl", chain, props => {
    const state = props.getState();
    const extensionContentSearchSettings = state.context.settings.settingsCollection.extensionContentSearchSettings;
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;

    if (props.redirectUrl) {
        props.parameter.goToUrl(props.redirectUrl);
    } else {
        const encodedQuery = encodeURIComponent(props.parameter.query);

        if (enableContentSearchResults) {
            /*
                Need to add currentTab in the path to avoid deleting currentTab from the query string when trying to perform the same search several times
                and it is also necessary to have the default currentTab in the url
            */
            const contentSearchPrefixUrl = getContentSearchUrl(
                props.parameter.query,
                props.parameter.searchPath,
                getContentSearchCurrentTab(state) || constants.contentSearch.tabKey.products,
            );

            props.parameter.goToUrl(contentSearchPrefixUrl, false);
        } else {
            props.parameter.goToUrl(`/${props.parameter.searchPath}?query=${encodedQuery}`, false);
        }

        if (props.isSearchPage) {
            // if we already on the Search page then scroll to top
            window.scrollTo(0, 0);
        }
    }
});

replaceInChain(chain, baseGoToUrl, GoToUrl);
